import React, { useEffect, useState } from 'react';

interface BuildInfo {
  timestamp: number;
  date: string;
  version: string;
}

const VersionInfo: React.FC = () => {
  const [buildInfo, setBuildInfo] = useState<BuildInfo | null>(null);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    // Try to get build info from environment variables first
    const envBuildTime = process.env.REACT_APP_BUILD_TIME;
    const envBuildDate = process.env.REACT_APP_BUILD_DATE;
    const envVersion = process.env.REACT_APP_VERSION;

    if (envBuildTime && envBuildDate && envVersion) {
      setBuildInfo({
        timestamp: parseInt(envBuildTime),
        date: envBuildDate,
        version: envVersion
      });
    } else {
      // Fallback to fetching build-info.json
      fetch('/build-info.json')
        .then(response => response.json())
        .then((data: BuildInfo) => setBuildInfo(data))
        .catch(error => {
          console.log('Build info not available:', error);
          // Set fallback version info
          setBuildInfo({
            timestamp: Date.now(),
            date: new Date().toISOString(),
            version: '1.0.0'
          });
        });
    }
  }, []);

  if (!buildInfo) return null;

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleString();
  };

  return (
    <div className="fixed bottom-2 left-2 z-30">
      <button
        onClick={() => setShowDetails(!showDetails)}
        className="text-xs text-slate-400 hover:text-slate-600 transition-colors bg-white/80 px-2 py-1 rounded"
        title="Version Information"
      >
        v{buildInfo.version}
      </button>
      
      {showDetails && (
        <div className="absolute bottom-8 left-0 bg-white border border-slate-200 rounded-lg shadow-lg p-3 min-w-[200px] text-xs">
          <div className="space-y-1">
            <div>
              <span className="font-medium">Version:</span> {buildInfo.version}
            </div>
            <div>
              <span className="font-medium">Built:</span> {formatDate(buildInfo.date)}
            </div>
            {/* <div>
              <span className="font-medium">Build ID:</span> {buildInfo.timestamp}
            </div> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default VersionInfo;